{
  "limits": {
    "overlay": {
      "title": {
        "customColoursOnModels": "Cores personalizadas nos modelos"
      },
      "content": {
        "text1": {
          "customColoursOnModels": "No momento, você não tem acesso para adicionar cores personalizadas aos seus modelos 3D. Atualize para trabalhar nos planos de forma colaborativa com outros membros da equipe.",
          "customSharedPlanExpiryDuration": "Atualize para definir durações de expiração personalizadas para links compartilhados."
        }
      }
    }
  }
}